import { createContext, Dispatch, FC, SetStateAction, useState } from 'react';

import type { ServiceModuleInterface } from '@src/domain/types';

interface Context {
  serviceModules: ServiceModuleInterface[];
  setServiceModules: Dispatch<SetStateAction<ServiceModuleInterface[]>>;
  selectedModule: ServiceModuleInterface | null;
  setSelectedModule: Dispatch<SetStateAction<ServiceModuleInterface | null>>;
  appendModules: (modules: ServiceModuleInterface[]) => void;
}

const defaultServiceModuleContext = {
  serviceModules: [],
  setServiceModules: () => {},
  selectedModule: null,
  setSelectedModule: () => {},
  appendModules: () => {},
  selectedInfo: null,
  setSelectedInfo: () => {},
};

export const ServiceModuleContext = createContext<Context>(defaultServiceModuleContext);
export const ServiceModuleProvider: FC = ({ children }) => {
  const [serviceModules, setServiceModules] = useState<ServiceModuleInterface[]>([]);
  const [selectedModule, setSelectedModule] = useState<ServiceModuleInterface | null>(null);
  const appendModules = (modules: ServiceModuleInterface[]) =>
    setServiceModules([...serviceModules, ...modules]);

  return (
    <ServiceModuleContext.Provider
      value={{
        serviceModules,
        setServiceModules,
        selectedModule,
        setSelectedModule,
        appendModules,
      }}
    >
      {children}
    </ServiceModuleContext.Provider>
  );
};
